import React from 'react';

import { config } from './config';

import Page from '../../components/Page';

export const Payments: React.FC = () => <Page contents={config}/>